/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAIcon20Regular = forwardRef('DataChartBarsAIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16.75 3.5a.75.75 0 0 0-1.5 0v13a.75.75 0 0 0 1.5 0v-13Z" }),
        React.createElement("path", { d: "M8.75 6.5a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0v-10Z" }),
        React.createElement("path", { d: "M4.75 12a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0V12Z" }),
        React.createElement("path", { d: "M12 8.25a.75.75 0 0 1 .75.75v7.5a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z" })));
});
